import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
	collection,
	doc,
	getDocs,
	onSnapshot,
	query,
	where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import firestore from ".";

export const getMessagesUnreadCountByUser = (
	userId,
	conversationId,
	callback,
) => {
	const auth = getAuth();
	if (!auth.currentUser) return () => {};

	const conversationRef = doc(firestore, "conversations", conversationId);

	return onSnapshot(
		conversationRef,
		(docSnapshot) => {
			if (docSnapshot.exists()) {
				const conversationData = docSnapshot.data();
				const unreadMessages = conversationData.unreadMessages || {};
				const unreadCount = unreadMessages[String(userId)];
				callback(unreadCount);
			} else {
				console.log("No such document!");
				callback(0);
			}
		},
		(error) => {
			console.error("Error in unread count snapshot:", error);
			callback(0);
		},
	);
};

export const useAuth = () => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const auth = getAuth();
		const unsubscribe = onAuthStateChanged(auth, (user) => {
			setUser(user);
			setLoading(false);
		});

		return () => unsubscribe();
	}, []);

	return { user, loading };
};

export const useUnreadMessageCount = (userId, role) => {
	const [unreadCount, setUnreadCount] = useState(0);
	const { user, loading } = useAuth();

	useEffect(() => {
		if (loading || !user || !userId) return;

		const conversationsRef = collection(firestore, "conversations");
		const q = query(
			conversationsRef,
			where("participantIds", "array-contains", userId?.toString()),
		);

		const unsubscribe = onSnapshot(
			q,
			(snapshot) => {
				const conversationList = snapshot.docs.map((doc) => ({
					id: doc.id,
					...doc.data(),
				}));

				const relevantConversations = conversationList.filter(
					(conversation) => {
						const participants = conversation.participants || [];
						return participants.some(
							(p) => p.userId === userId?.toString() && p.role === role,
						);
					},
				);

				const count = relevantConversations.reduce((acc, conversation) => {
					return acc + (conversation.unreadMessages?.[userId?.toString()] || 0);
				}, 0);

				setUnreadCount(count);
			},
			(error) => {
				console.error("Error fetching unread message count: ", error);
			},
		);

		return () => unsubscribe();
	}, [userId, role, user, loading]);

	return unreadCount;
};
